import { Registration } from '../../../components/user/Registration'
import { Plan } from '../../../lib/plans'
import { SEARCH_PARAM_PLAN_ID } from '../../../constants/strings'

interface Params {
  plan: Plan
}

export const RegistrationStep = ({plan}: Params) => {
  return <div className="p-4">
      <span className="p-2 text-gray-700 dark:text-gray-300">Please signin or create an account for {plan.title}</span>
      <Registration redirectUrl={`/?${SEARCH_PARAM_PLAN_ID}=${plan.external_id}`}/>
  </div>
}
